/**
 * Zamanaşımı timeline için saf yardımcılar (video editor tarzı ölçek / yüzde).
 */

export function formatTarihKisa(tarih) {
  const d = new Date(tarih);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}

/** Başlangıç/bitiş aralığında tarihin 0–100 yüzdesi */
export function tarihYuzdesi(tarih, baslangic, bitis) {
  const t = new Date(tarih).getTime();
  const a = new Date(baslangic).getTime();
  const b = new Date(bitis).getTime();
  if (b <= a) return 0;
  const p = ((t - a) / (b - a)) * 100;
  return Math.min(100, Math.max(0, p));
}

/** İki tarih arası genişlik yüzdesi (modül-içi; runLaneStyle/durmaBandStyle kullanır) */
function aralikGenisligiYuzde(baslangic, bitis, aralikBas, aralikBit) {
  const start = tarihYuzdesi(baslangic, aralikBas, aralikBit);
  const end = tarihYuzdesi(bitis, aralikBas, aralikBit);
  return Math.max(0, end - start);
}

/** Görünüm aralığı: suçtan en geç tarihe + küçük pay */
export function hesaplaGorunumAraligi(sucTarihi, olaganustuZamanAsimi, bugun = new Date()) {
  const bas = new Date(sucTarihi);
  const olaganustu = new Date(olaganustuZamanAsimi);
  const son = new Date(bugun);
  let bit = new Date(Math.max(olaganustu.getTime(), son.getTime()));
  const span = bit - bas;
  const pay = span > 0 ? span * 0.03 : 1000 * 60 * 60 * 24 * 30;
  bit = new Date(bit.getTime() + pay);
  return { bas, bit };
}

/** Yıl tikleri (ruler) */
export function yilTikleri(bas, bit) {
  const yillar = [];
  const y0 = bas.getFullYear();
  const y1 = bit.getFullYear();
  for (let y = y0; y <= y1; y++) {
    const t = new Date(y, 0, 1);
    yillar.push({ yil: y, tarih: t });
  }
  return yillar;
}

/** Bir "koşu" (run) çubuğunun konumu: sol/uzunluk yüzdesi + kesilme (✂) noktası. */
export function runLaneStyle(run, rangeBas, rangeBit) {
  return {
    leftPct: tarihYuzdesi(run.start, rangeBas, rangeBit),
    widthPct: aralikGenisligiYuzde(run.start, run.end, rangeBas, rangeBit),
    supersededLeftPct: run.supersededAt
      ? tarihYuzdesi(run.supersededAt, rangeBas, rangeBit)
      : null,
  };
}

/** Bir durma bandının konumu (sol/uzunluk yüzdesi). */
export function durmaBandStyle(durma, rangeBas, rangeBit) {
  return {
    leftPct: tarihYuzdesi(durma.start, rangeBas, rangeBit),
    widthPct: aralikGenisligiYuzde(durma.start, durma.end, rangeBas, rangeBit),
  };
}

/** "Bugün" oynatma kafası (playhead) yüzdesi; aralık dışındaysa null. */
export function playheadPct(bugun, rangeBas, rangeBit) {
  const t = new Date(bugun).getTime();
  const a = new Date(rangeBas).getTime();
  const b = new Date(rangeBit).getTime();
  if (t < a || t > b || b <= a) return null;
  return ((t - a) / (b - a)) * 100;
}

/**
 * Yüzde olarak birbirine yakın işaretlerin etiketlerinin üst üste binmesini önlemek için
 * sıra (lane) numarası verir (0 = en üst satır).
 * @param {Array<{ leftPct: number, key?: string }>} markers
 * @param {number} minGapPct — bundan az aralıkta üst üste kabul edilir
 */
export function isaretlereLaneAta(markers, minGapPct = 4) {
  const sortedIdx = markers
    .map((m, i) => ({ i, leftPct: m.leftPct }))
    .sort((a, b) => a.leftPct - b.leftPct);

  let prevLeft = -Infinity;
  let lane = 0;
  const lanes = new Array(markers.length).fill(0);

  for (const { i, leftPct } of sortedIdx) {
    if (prevLeft !== -Infinity && leftPct - prevLeft < minGapPct) {
      lane += 1;
    } else {
      lane = 0;
    }
    lanes[i] = lane;
    prevLeft = leftPct;
  }

  return lanes;
}
